// TODO: make this work with SSR (see hardcoded phone)

const parse = (name: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const element = document.querySelector(`meta[name='${name}']`);
  if (element) {
    return element.getAttribute('content') || null;
  } else {
    return null;
  }
};

export const STRIPE_PUBLISHABLE_KEY = parse('stripe-publishable-key');

export const CONTACT_PHONE = parse('contact-phone') || '1-800-971-3674';

export const WT_COOKIE_EXPIRES = 365 * 20; // i.e. 20 years

export const API_BASE_URL = parse('api-base-url');

export const GOOGLE_PUBLIC_API_KEY = parse('google-public-api-key');

export const SENTRY_DSN = parse('sentry_dsn');

export const HEROKU_SLUG_COMMIT = parse('heroku-slug-commit') || undefined;
